import { useAnalytics } from 'libs/utils/site/analytics';
import { CustomActionButton } from 'pages/custom/shared/CustomHeader/CustomActionButton';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    programmeTitle?: string;
    programeId: string;
    className?: string;
}

export const FestivalButtons = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);
    const ctxModal = useContext(CtxModal);
    const analytics = useAnalytics();

    let companiesText = Localization.PLACES;
    if (ctxModal.storyList?.visibleStoryIds?.length && ctxView.conectedDetails?.length) {
        const totalCompaniesCount =
            ctxView.conectedDetails?.length -
            (ctxView.customPageConfig.storyIdsExcludedInList?.length ?? 0);

        companiesText += ` ${ctxModal.storyList?.visibleStoryIds?.length}/${totalCompaniesCount}`;
    }

    function openProgramme() {
        const story = ctxView.conectedDetails?.find((s) => s.storyId === props.programeId);
        if (story) {
            ctxModal.setDetailModal({
                id: props.programeId,
                detail: story,
                markerId: null
            });
        }
    }

    return (
        <S_FestivalButtons className={props.className}>
            <S_Button
                iconSet="far"
                iconName={'book'}
                text={props.programmeTitle ?? Localization.PROGRAMME}
                onClick={(e) => {
                    analytics.track('custom_button.clicked', {
                        action: 'sidebar_programme.opened'
                    });
                    openProgramme();
                    e.stopPropagation();
                }}
            />

            <S_Button
                iconSet="far"
                iconName="location-dot"
                text={companiesText}
                onClick={() => {
                    analytics.track('custom_button.clicked', {
                        action: 'sidebar_list.opened'
                    });
                    ctxModal.setShowListOfStories(true);
                }}
            />

            <S_Button
                iconSet="far"
                iconName="highlighter"
                text={
                    ctxView.forceMarkersHighlight
                        ? Localization.UNHIGHLIGHT
                        : Localization.HIGHLIGHT
                }
                onClick={(e: React.MouseEvent) => {
                    analytics.track('custom_button.clicked', {
                        action: 'highlight_markers'
                    });
                    ctxView.setForceMarkersHighlight(!ctxView.forceMarkersHighlight);
                    e.stopPropagation();
                }}
            />
        </S_FestivalButtons>
    );
};

const S_FestivalButtons = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    @media only screen and (min-width: 1259px) {
        width: unset;
    }
`;

const S_Button = styled(CustomActionButton)`
    width: 100%;
    @media only screen and (min-width: 1259px) {
        min-width: 150px;
        width: unset;
    }
`;
